/**
 * Block-explorer links for transactions the user just signed.
 *
 * Every action that costs gas ends with the user being shown its transaction:
 * a hash they can open on the explorer is the only proof they have that what
 * the interface claims happened actually happened.
 */
const EXPLORERS: Record<number, string> = {
  1: 'https://etherscan.io',
  8453: 'https://basescan.org',
  84532: 'https://sepolia.basescan.org'
}

export function txUrl(hash: string, chainId = 8453): string {
  const base = EXPLORERS[chainId] ?? EXPLORERS[8453]
  return `${base}/tx/${hash}`
}

export function shortHash(hash: string): string {
  return `${hash.slice(0, 10)}…${hash.slice(-8)}`
}
